export enum EnumDocumentsNavigationFrom {
  Contracts = 1,
  Procedures = 2,
  Trades = 3
}
